import { FC, ReactNode, useEffect, useState } from "react";

/**
 * Server renders and the first (hydrating) client render must produce identical markup,
 * so client-only parts are deferred until after hydration has committed.
 * The server cannot rely on `typeof window` because SSR mocks window and document.
 */
export const ssrState = {
  isServer: false,
  isHydrating: false,
};

const ClientOnly: FC<{ children: ReactNode }> = ({ children }) => {
  const [mounted, setMounted] = useState(!ssrState.isServer && !ssrState.isHydrating);

  useEffect(() => {
    if (!mounted) setMounted(true);
  }, [mounted]);

  return mounted ? <>{children}</> : null;
};

export default ClientOnly;
import { FC, ReactNode, useEffect, useState } from "react";

/**
 * Server renders and the first (hydrating) client render must produce identical markup,
 * so client-only parts are deferred until after hydration has committed.
 * The server cannot rely on `typeof window` because SSR mocks window and document.
 */
export const ssrState = {
  isServer: false,
  isHydrating: false,
};

const ClientOnly: FC<{ children: ReactNode }> = ({ children }) => {
  const [mounted, setMounted] = useState(!ssrState.isServer && !ssrState.isHydrating);

  useEffect(() => {
    if (!mounted) setMounted(true);
  }, [mounted]);

  return mounted ? <>{children}</> : null;
};

export default ClientOnly;
